import Canvas from "./Canvas.vue";
import Menu from "./Menu.vue";

export default {
  Canvas,
  Menu,
};
